import Section from './Section'
import './Section.scss'

export type { Props as SectionProps } from './Section'
export default Section